import React, { useState } from "react";
import AccordBtn from "../../../../core-components/AccordBtn/AccordBtnUI";
import CancellationPolicyStatusUI from "../CancellationPolicyStatus/CancellationPolicyStatusUI";
import * as S from "./CancellationPolicy.styles";
import { gcBookingReviewScreen, pushCtaOmniEvents } from "../../../../../shared/config/omni";
import { CANCELLATION_POLICY_DROPDOWN, MOB_CABS_REVIEW } from "../../../../../shared/utils/util-constants";
import { CTA_TYPE, getActionNameForOmniture } from "../../../../../shared/utils/omni-utils";
import { CABS_REVIEW_PAGE } from "../../../../../shared/utils/util-constants";
import { CABS_REVIEW_ROUTE } from "../../../../../shared/utils/util-constants";

interface ICancellationPolicy {
	heading?: string;
	cancellationData: Array<{}>
	margin?: string;
};

const CancellationPolicyUI: React.FC<ICancellationPolicy> = ({
	heading = 'Cancellation Policy',
	cancellationData = [],
	margin="0 0 2rem 0"
}) => {
	
  const [toggle, setToggle] = useState(false);
  const handlePolicy = () => {
    if(!toggle){
      pushCtaOmniEvents(getActionNameForOmniture(gcBookingReviewScreen, CANCELLATION_POLICY_DROPDOWN, true), CTA_TYPE.HYPER_LINK, CABS_REVIEW_PAGE, CABS_REVIEW_ROUTE)
    }else{
      pushCtaOmniEvents(getActionNameForOmniture(gcBookingReviewScreen, CANCELLATION_POLICY_DROPDOWN), CTA_TYPE.HYPER_LINK, CABS_REVIEW_PAGE, CABS_REVIEW_ROUTE)
    }
    setToggle(!toggle);
  };

  return (
    <>
      {cancellationData?.length ? (
        <S.PolicyCont margin={margin}>
          <S.PolicyHeader onClick={handlePolicy}>
            <div>
              <h3>{heading}</h3>
            </div>
            <AccordBtn active={toggle} /> 
          </S.PolicyHeader>
          {toggle && (
            <S.PolicyContent>
              {!!cancellationData?.length ? (
                <CancellationPolicyStatusUI cancellationData={cancellationData} />
              ) : null}
            </S.PolicyContent>
          )}
        </S.PolicyCont>
      ) : null}
    </>
  );
};

export default CancellationPolicyUI;
